'use strict';

/* injects from baggage-loader */

module.exports = {
  accessToken: '17861c08d87a4c389ddd50ad236771a1',
  captureUncaught: true,
  payload: {
    environment: process.env.NODE_ENV
  }
};


//////////////////
// WEBPACK FOOTER
// ./rollbar.config.js
// module id = 644
// module chunks = 1